import { useEffect, useState } from "react";
import API from "../services/api";

export default function Settings() {
  const [form, setForm] = useState({
    school_name: "",
    address: "",
    phone: "",
    email: "",
    principal_name: "",
    logo_url: ""
  });

    const [academicYears, setAcademicYears] = useState([]);


  const fetchSettings = async () => {
    try {
      const res = await API.get("/settings");
      setForm({
        school_name: res.data.school_name || "",
        address: res.data.address || "",
        phone: res.data.phone || "",
        email: res.data.email || "",
        principal_name: res.data.principal_name || "",
        logo_url: res.data.logo_url || ""
      });
    } catch (err) {
      alert("Unable to fetch school settings");
    }
    };

    const fetchAcademicYears = async () => {

        try {

            const res = await API.get("/settings/academic-years");

            console.log("Academic Years:", res.data);

            setAcademicYears(res.data);

        } catch (err) {

            console.log(err);

        }

    };

    const activateAcademicYear = async (id) => {

        try {

            await API.put(
                `/settings/academic-years/${id}/activate`
            );

            fetchAcademicYears();

            alert("Academic Year Activated");

        }

        catch (err) {

            alert("Activation Failed");

        }

    };

    //const fetchAcademicYears = async () => {

    //    alert("fetchAcademicYears called");

    //    try {

    //        const res = await API.get("/settings/academic-years");

    //        alert(JSON.stringify(res.data));

    //        setAcademicYears(res.data);

    //    } catch (err) {

    //        alert(err.message);

    //    }

    //};


    useEffect(() => {

        fetchSettings();

        fetchAcademicYears();

    }, []);

    


  const handleSave = async () => {
    try {
      await API.post("/settings/save", form);
      alert("School settings saved successfully");
    } catch (err) {
      alert("Failed to save settings");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        School Profile Settings
      </h1>

      <div className="bg-white shadow p-6 rounded">

        <input
          placeholder="School Name"
          value={form.school_name}
          onChange={(e) =>
            setForm({ ...form, school_name: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <textarea
          placeholder="Address"
          value={form.address}
          onChange={(e) =>
            setForm({ ...form, address: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Phone"
          value={form.phone}
          onChange={(e) =>
            setForm({ ...form, phone: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Email"
          value={form.email}
          onChange={(e) =>
            setForm({ ...form, email: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Principal Name"
          value={form.principal_name}
          onChange={(e) =>
            setForm({ ...form, principal_name: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Logo URL"
          value={form.logo_url}
          onChange={(e) =>
            setForm({ ...form, logo_url: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <button
          onClick={handleSave}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Save Settings
        </button>

              <hr className="my-8" />

              <h2 className="text-2xl font-bold mb-4">
                  Academic Years
              </h2>

              <div className="bg-white shadow rounded">

                  <table className="w-full">

                      <thead>

                          <tr className="bg-gray-100">

                              <th className="p-3 text-left">
                                  Academic Year
                              </th>

                              <th className="p-3 text-center">
                                  Status
                              </th>

                          </tr>

                      </thead>

                      <tbody>

                          {academicYears.map((year) => (

                              <tr key={year.id} className="border-t">

                                  <td className="p-3">
                                      {year.academic_year}
                                  </td>

                                  <td className="p-3 text-center">

                                      {year.is_active === 1 ? (

                                          <span className="text-green-600 font-bold">
                                              Active
                                          </span>

                                      ) : (

                                          <button
                                              className="bg-blue-600 text-white px-4 py-1 rounded"
                                              onClick={() =>
                                                  activateAcademicYear(year.id)
                                              }
                                          >
                                              Activate
                                          </button>

                                      )}

                                  </td>

                              </tr>

                          ))}

                      </tbody>

                  </table>

              </div>

      </div>
    </div>
  );
}